import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../config/axios.config'
import { GET_PROPERTIES_ENDPOINT } from '../../Constants'

export const getPropertyTransactionById = createAsyncThunk('property/:id', async (propertyId: any): Promise<any> => {
  const responseData = await api.get(`/${GET_PROPERTIES_ENDPOINT}/${propertyId}`)
  return responseData.data
})
